import { PaymentData } from '../../../types/TransactionDetail';
import RetryApplePayBtn from '../RetryApplePayBtn';
import RetryBtn from '../RetryBtn';
import RetryLinePayBtn from '../RetryLinePayBtn';
import S from './style';

export interface PropsPaymentData extends PaymentData {
  transaction_no: string;
  transaction_status: string;
  transaction_hint: string;
  created_at: number;
  PAY_NAME: string;
}

interface Props {
  patchTransaction: Function;
  paymentData: PropsPaymentData;
  setDirectPayModalState: Function;
  transactionID: number;
}

export default function RetryBtnGroup(props: Props) {
  return (
    <S.RetryBtnGroup>
      <RetryApplePayBtn {...props} />
      <RetryLinePayBtn {...props} />
      <RetryBtn {...props} />
    </S.RetryBtnGroup>
  );
}
